import React from 'react'

interface Props {
  onNext: () => void
  translate: (key: string) => string
}

const Demo: React.FC<Props> = ({ onNext, translate }) => {
  return (
    <main className="min-h-screen flex flex-col items-center bg-gray-100 px-4 py-6 sm:py-10"> 
      {/* Header */}
      <header className="flex flex-col items-center text-center mb-6 sm:mb-10"> 
        <h1 className="text-xl sm:text-2xl font-semibold mt-2 sm:mt-4"> 
          {translate('risk_assessment.demo.heading')}
        </h1>
      </header>

      {/* Info Card */}
      <section className="w-full max-w-2xl flex flex-col flex-1 bg-white rounded-xl shadow-md border p-4 sm:p-6 mb-4"> 
        <p className="text-gray-500 text-sm leading-relaxed font-medium mb-3"> 
          {translate('risk_assessment.demo.info_text')}
        </p>

        <div className="mb-3"> 
          <p className="font-semibold text-sm sm:text-base"> 
            {translate('risk_assessment.demo.how_it_works')}
          </p>
          <ul className="list-decimal list-inside text-gray-500 text-xs sm:text-sm leading-relaxed font-medium space-y-0.5 sm:space-y-1"> {/* Smaller font and tighter space */}
            <li>
              <span className="font-semibold text-black">
                {translate('risk_assessment.demo.quick_questionnaire')}
              </span>{' '}
              – {translate('risk_assessment.demo.quick_questionnaire_time')}
            </li>
            <li>
              <span className="font-semibold text-black">
                {translate('risk_assessment.demo.vital_signs_scan')}
              </span>{' '}
              – {translate('risk_assessment.demo.vital_signs_scan_time')}
            </li>
            <li>
              <span className="font-semibold text-black">
                {translate('risk_assessment.demo.instant_report')}
              </span>{' '}
              – {translate('risk_assessment.demo.instant_report_desc')}
            </li>
          </ul>
        </div>

        <div className="text-gray-500 flex-grow overflow-y-auto custom-scrollbar pr-1"> 
          <p className="font-semibold text-black text-sm sm:text-base mb-1"> 
            {translate('risk_assessment.demo.before_you_start')}
          </p>
          <p className="font-medium text-xs sm:text-sm mb-2"> 
            {translate('risk_assessment.demo.best_results')}
          </p>
          <ul className="list-disc list-inside text-xs sm:text-sm leading-relaxed font-medium space-y-0.5 sm:space-y-1"> 
            <li>{translate('risk_assessment.demo.tip_relax')}</li>
            <li>{translate('risk_assessment.demo.tip_light')}</li>
            <li>{translate('risk_assessment.demo.tip_coffee')}</li>
            <li>{translate('risk_assessment.demo.tip_posture')}</li>
          </ul>
        </div>
      </section>

      {/* Footer Button */}
      <footer className="w-full max-w-2xl px-4 pb-4"> 
        <button
          type="button"
          onClick={onNext}
          className="w-full py-3 rounded-lg font-medium transition-colors duration-200 bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-400 focus:outline-none"
        >
          {translate('risk_assessment.demo.start_button')}
        </button>
      </footer>
    </main>
  )
}

export default Demo